<template>
  <div
    class="absolute inset-0 bg-green1/30 backdrop-blur-xl h-16 flex items-center px-6 justify-between z-30"
  >
    <div class="font-semibold text-white">
      <p
        class="tracking-wider text-[13px] md:text-[15px] lg:text-[19px] font-light"
      >
        DNSC Information Systems Gateway
      </p>
    </div>

    <div>
      <img
        src="../assets/img/dnsc-logo-white.png"
        alt=""
        class="h-[30px] md:h-[45px] lg:h-[40px] cursor-pointer hover:scale-105 duration-300"
        @click="toggleSetting"
      />
    </div>
    <settingmodal v-if="isSettingModal" />
  </div>
</template>

<script>
import settingmodal from "./modals/portal-setting-modal.vue";

export default {
  name: "NavigationPages",
  components: {
    settingmodal,
  },
  data() {
    return {
      isSettingModal: false,
    };
  },
  methods: {
    toggleSetting() {
      this.isSettingModal = !this.isSettingModal;
    },
  },
};
</script>

<style>
/* Add styles here if needed */
</style>
